import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import { firebaseConnect } from 'react-redux-firebase'
import filter from 'lodash/filter';
import * as folioActions from '../../actions/folio-actions';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import SimpleSpinner from '../../components/SimpleSpinner/SimpleSpinner';
import CrewMenu from '../../components/CrewMenu/CrewMenu';
import Section from '../../components/Section/Section';
import Story from '../../components/Story/Story';
import styled from 'styled-components';
import smoothScroll from '../../utility/smoothScroll';

import PropTypes from 'prop-types';

import '../../styles.scss';

class InsideContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crew: 0,
      showExtended: false
    };
  }

  handleClick = () => {
    this.setState(() => ({ showExtended: false }), () => {
      smoothScroll.scrollTo('storyTop');
    })
  };

  handleShowMore = () => { this.setState(() => ({ showExtended: !this.state.showExtended }))};

  render() {
    const isMobile = window.innerWidth < 900; //(/Mobi/.test(navigator.userAgent));
    const allStories = this.props.stories
        && filter(this.props.stories, { section: 'process'})
            .sort((a,b) => (Number(a.order) > Number(b.order)) ? 1 : ((Number(b.order) > Number(a.order)) ? -1 : 0)) || [];
    const selectedStory = allStories
        && filter(allStories, { path: this.props.match.params.path })[0] || [];
    const selectedSection = find(this.props.sections, { name: this.props.section });
    let sidebarPhotos = selectedStory && selectedStory.media && this.state.showExtended ?
        filter(selectedStory.media, { tag: 'sidebar'} ) :
        filter(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('sidebar'));
    // sidebarPhotos = isMobile ? filter(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('mobile') ): sidebarPhotos;
    sidebarPhotos = sortBy(sidebarPhotos, 'order');
    const backgroundImage = find(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('background') );
    const iconImage = find(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('icon') );

    const transitionProperties = {
      transitionName: "fadein",
      transitionAppear: true,
      transitionAppearTimeout: 3000,
      transitionEnterTimeout: 3000,
      transitionLeaveTimeout: 3000,
      transitionEnter: true,
      transitionLeave: true,
      key: 1
    };

    const Process = styled.div`
      margin-top: 100px;
      
      @media (max-width: 640px) {
      margin-top: 100px;
      }
    `;


    return (
      <Process>
        { selectedStory && selectedStory.path ?
          <div id="storyTop">
            { (this.props.location.pathname === '/process' || this.props.location.pathname === '/process/') ?
                <Section transitionProperties={ transitionProperties }
                         copy={ selectedSection && selectedSection.body }
                         intro={ selectedSection && selectedSection.intro }
                /> :
                  <Story backgroundImage={ backgroundImage }
                         isMobile={ isMobile }
                         selectedStory={ selectedStory }
                         sidebarPhotos={ sidebarPhotos }
                         handleClick={ this.handleClick }
                         showExtended={ true }
                         iconImage={ iconImage }
                         allStories={ allStories }
                         handleShowMore={ () => { this.handleShowMore();
                           setTimeout(() => { smoothScroll.scrollTo('extendedStory') }, 1000);
                         } }
                  /> }
          </div> : <SimpleSpinner /> }
          <CrewMenu title="Explore our process"
                    isMobile={ isMobile }
                    allStories={ allStories }
                    handleClick={ this.handleClick }/>
      </Process> );
  }
}

InsideContainer.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default compose(
    firebaseConnect(['stories', 'sections']),
    connect(
        (state) => ({
          inside: state.inside,
          stories: state.firebase.data.stories,
          sections: state.firebase.data.sections,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(InsideContainer)



// WEBPACK FOOTER //
// ./src/containers/how-we-work/process.js